// extracted by mini-css-extract-plugin
export default {"reValidateCardSection":"Baa-z","paymentSection":"Caa-z","disabled":"Daa-z","sectionButtons":"Eaa-z","usingAmazonPayMsg":"Faa-z"};